var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from 'react';
import chroma from 'chroma-js';
import { styled } from '@web/theme';
import { useBlockEdit, blockEditActions, BlockType } from '../../../';
export var BlockNew = memo(function (block) {
    var _a = useBlockEdit(), blockEdit = _a.blockEdit, dispatchBlockEdit = _a.dispatchBlockEdit;
    var onSelectText = function () {
        dispatchBlockEdit({
            type: blockEditActions.ADD,
            block: __assign(__assign(__assign({}, block), blockEdit.data), { _type: BlockType.TEXT, text: '' })
        });
    };
    var onSelectImage = function () {
        dispatchBlockEdit({
            type: blockEditActions.ADD,
            block: __assign(__assign(__assign({}, block), blockEdit.data), { _type: BlockType.IMAGE, backgroundImage: '' })
        });
    };
    if (!blockEdit.enabled)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Type, { onClick: onSelectImage }, "Image"),
        React.createElement(Type, { onClick: onSelectText }, "Text")));
});
var Type = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex: none;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: none;\n\toutline: none;\n\tpadding: .5rem 1.2rem;\n\tcursor: pointer;\n\tbackground: ", ";\n\t\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\tflex: none;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: none;\n\toutline: none;\n\tpadding: .5rem 1.2rem;\n\tcursor: pointer;\n\tbackground: ", ";\n\t\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return chroma(theme.block.bg).darken(1).alpha(.2).hex();
}, function (_a) {
    var theme = _a.theme;
    return chroma(theme.block.bg).darken(1).alpha(.5).hex();
});
var templateObject_1;
